<!-- Компактная кнопка звонка по переданному номеру телефона. -->
<template>
  <a
    class="base-phone-button"
    :href="phoneHref"
    :aria-label="ariaLabel"
    :title="ariaLabel"
    @click.stop
    @mousedown.stop
    @contextmenu.stop
  >
    <AppIcon name="phone" :size="16" />
  </a>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "BasePhoneButton",

  components: { AppIcon },

  props: {
    phone: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      default: "Позвонить",
    },
  },

  computed: {
    phoneHref() {
      return `tel:${this.phone.replace(/[^\d+]/g, "")}`;
    },
  },
};
</script>

<style scoped>
.base-phone-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border: 1px solid var(--color-green);
  border-radius: 5px;
  background: var(--color-green);
  color: #fff;
  text-decoration: none;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.base-phone-button:hover,
.base-phone-button:focus-visible {
  border-color: var(--color-green-hover);
  background: var(--color-green-hover);
}

.base-phone-button:focus-visible {
  outline: 2px solid var(--color-green);
  outline-offset: 2px;
}
</style>
